import { AlertVariant, KariusAlert } from '@kariusdx/design-system';
import CloseIcon from '@mui/icons-material/Close';
import { Snackbar, Stack } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { createContext, ReactNode, useContext, useState } from 'react';

interface SnackOptions {
  title: string | ReactNode;
  subtitle?: string | ReactNode | undefined;
  severity: AlertVariant;
  autoHideDuration?: number;
  closeButton?: boolean;
}

export interface SnackbarHandle {
  showSnack: (options: SnackOptions) => void;
  hideSnack: () => void;
}

const SnackContext = createContext<SnackbarHandle>({} as any);

export const GlobalSnackProvider = ({ children }: { children: ReactNode }) => {
  const [snackOptions, setSnackOptions] = useState<SnackOptions | undefined>();
  const [open, setOpen] = useState(false);

  const showSnack = (options: SnackOptions) => {
    setOpen(true);
    setSnackOptions(options);
  };

  const hideSnack = () => {
    setOpen(false);
  };
  return (
    <>
      <Snackbar
        data-test={'snackbar'}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        open={open}
        onClose={() => setOpen(false)}
        disableWindowBlurListener
        autoHideDuration={snackOptions?.autoHideDuration ?? 3000}
        sx={{
          '& .alert-icon': {
            width: 16,
            height: 16,
          },
          '& .alert-text': {
            fontWeight: 700,
            fontSize: 14,
          },
          '& .subtitle': {
            fontSize: 12,
          },
        }}
      >
        <KariusAlert variant={snackOptions?.severity ?? 'info'} subtitle={snackOptions?.subtitle}>
          <Stack
            direction={'row'}
            sx={{
              width: '100%',
            }}
          >
            <p>{snackOptions?.title ?? ''}</p>
            {snackOptions?.closeButton && (
              <IconButton onClick={hideSnack}>
                <CloseIcon />
              </IconButton>
            )}
          </Stack>
        </KariusAlert>
      </Snackbar>
      <SnackContext.Provider
        value={{
          showSnack,
          hideSnack,
        }}
      >
        {children}
      </SnackContext.Provider>
    </>
  );
};

export const useSnack = () => {
  return useContext(SnackContext);
};
